import React from 'react';
import { Modal } from '@appkit4/react-components/modal';
import './DeleteModal.scss';

interface DeleteModalProps {
    content: React.ReactNode;
    visible: boolean;
    onClose: () => void;
    title: string;
}

export const DeleteModal: React.FC<DeleteModalProps> = ({
    content,
    visible,
    onClose,
    title,
}) => {
    return (
        <Modal
            visible={visible}
            onCancel={() => onClose()}
            title={title}
            modalStyle={{ width: '33.75rem' }}
        >
            {content}
        </Modal>
    );
};

export default DeleteModal;
